"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
const HeroBackground = dynamic(() => import("./HeroBackground"), {
  ssr: false
});
import { useLanguage } from "@/contexts/LanguageContext";
import Deferred from "./Deferred";
import LogoTicker from "./LogoTicker";
import Navbar from "./Navbar";
export default function Hero() {
  const $ = _c(33);
  const {
    t
  } = useLanguage();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Deferred><HeroBackground accent="#4CB5FC" sea="#1854F0" /></Deferred>;
    t1 = <Navbar />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="w-2 h-2 rounded-full bg-brand-secondary shadow-[0_0_12px_var(--color-brand-secondary)]" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("hero.badge");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-border-default border border-border-hover text-text-secondary text-xs md:text-sm mb-6 mx-auto">{t2}{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("hero.title");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("hero.titleHighlight");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-secondary">{t6}</span>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight text-text-primary mb-6 leading-[1.1]">{t5}{" "}{t7}</h1>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("hero.subtitle");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <p className="max-w-3xl mx-auto text-lg md:text-xl text-text-secondary leading-relaxed mb-8">{t9}</p>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("hero.cta");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="group-hover:translate-x-1 transition-transform">↗</span>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11) {
    t13 = <div className="flex flex-col md:flex-row items-center justify-center gap-4"><a href="https://calendar.app.google/PuiskR6L6hR51Wfg7" target="_blank" rel="noopener noreferrer" className="group relative px-6 py-3 rounded-full bg-text-primary text-surface font-extrabold flex items-center gap-2 transition-all duration-300 shadow-[0_4px_20px_rgba(0,0,0,0.15)] dark:shadow-[0_4px_20px_rgba(255,255,255,0.15)] hover:scale-105 hover:shadow-[0_6px_30px_rgba(0,0,0,0.25)] dark:hover:shadow-[0_6px_30px_rgba(255,255,255,0.3)] hover:bg-brand-secondary hover:text-text-primary">{t11}{t12}</a></div>;
    $[23] = t11;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t13 || $[27] !== t4 || $[28] !== t8) {
    t14 = <div className="relative z-10 w-full max-w-4xl mx-auto px-6 pt-10 md:pt-20 pb-12 text-center flex-grow flex flex-col justify-center">{t4}{t8}{t10}{t13}</div>;
    $[25] = t10;
    $[26] = t13;
    $[27] = t4;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LogoTicker />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14) {
    t16 = <section className="relative min-h-screen overflow-hidden bg-surface flex flex-col justify-between">{t0}{t1}{t14}{t15}</section>;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
}